export const authorizationSystemTypes = [{
  id: 0,
  title: 'غیر سیستمی'
},
{
  id: 2,
  title: 'اعتبارسنجی ایران'
},
{
  id: 4,
  title: 'بتا بانک رفاه'
},
{
  id: 5,
  title: 'امضا دیجیتال - پیامکی'
},
{
  id: 6,
  title: 'ضامن با امضا پیامکی'
}
]

export const babats = [
  { id: "HOGHOGH", title: "واریز حقوق" },
  { id: "BIME", title: "امور بیمه خدمات" },
  { id: "DARMANI", title: "امور درمانی" },
  { id: "BOURS", title: "امور سرمایه گذاری و بورس" },
  { id: "ARZ", title: "امور ارزی در چارچوب ضوابط و مقررات" },
  { id: "GHARZ_AND_DION", title: "پرداخت قرض و تادیه دیون (قرض الحسنه، بدهی)" },
  { id: "BAZNESHASTEGI", title: "امور بازنشستگی" },
  { id: "MOAMELAT_MANGHOL", title: "معاملات اموال منقول" },
  { id: "MOAMELAT_GHEIR_MANGHOOL", title: "معاملات اموال غیر منقول" },
  { id: "NAGHDINEGI", title: "مدیریت نقدینگی" },
  { id: "GOMROK", title: "عوارض گمرکی" },
  { id: "MALIAT", title: "تسویه مالیاتی" },
  { id: "DOWLATI", title: "سایر خدمات دولتی" },
  { id: "TASHILAT", title: "تسهیلات و تعهدات" },
  { id: "VASIGHE", title: "تودیع وثیقه" },
  { id: "OMUMI", title: "هزینه عمومی و امور روزمره" },
  { id: "KHEIRIEH", title: "کمک‌های خیریه" },
  { id: "KALA", title: "خرید کالا" },
  { id: "KHADAMAT", title: "خرید خدمات" }
]

export const banks = [
  { id: "ENB", title: "بانک اقتصاد نوین" },
  { id: "ANS", title: "بانک انصار" },
  { id: "IRZ", title: "بانک ایران زمین" },
  { id: "PAR", title: "بانک پارسیان" },
  { id: "PAS", title: "بانک پاسارگاد" },
  { id: "TEJ", title: "بانک تجارت" },
  { id: "BTT", title: "بانک توسعه تعاون" },
  { id: "BTS", title: "بانک توسعه صادرات ایران" },
  { id: "HEK", title: "بانک حکمت ایرانیان" },
  { id: "KHMI", title: "بانک خاورمیانه" },
  { id: "DEY", title: "بانک دی" },
  { id: "REF", title: "بانک رفاه" },
  { id: "SAM", title: "بانک سامان" },
  { id: "BSP", title: "بانک سپه" },
  { id: "SAR", title: "بانک سرمایه" },
  { id: "SIN", title: "بانک سینا" },
  { id: "SHR", title: "بانک شهر" },
  { id: "BSI", title: "بانک صادرات ایران" },
  { id: "BSM", title: "بانک صنعت و معدن" },
  { id: "RES", title: "بانک قرض‌الحسنه رسالت" },
  { id: "MHR", title: "بانک قرض‌الحسنه مهر ایران" },
  { id: "GHA", title: "بانک قوامین" },
  { id: "BKA", title: "بانک کارآفرین" },
  { id: "BKV", title: "بانک کشاورزی ایران" },
  { id: "GAR", title: "بانک گردشگری" },
  { id: "BMK", title: "بانک مسکن" },
  { id: "MEL", title: "بانک ملت" },
  { id: "BMI", title: "بانک ملی ایران" },
  { id: "NOR", title: "بانک نور" },
  { id: "PST", title: "پست بانک" },
  { id: "MEH", title: "بانک مهر اقتصاد" }
]

export const transferTypes = [
  { id: "LOCAL", title: "صادرات به صادرات" },
  { id: "PAYA", title: "پایا" },
  { id: "SATNA", title: "ساتنا" },
  { id: "POL", title: "پل" }
]





export const sponsorStatuses = [
  { id: 0, title: 'در انتظار بررسی' },
  { id: 5, title: 'نقص مدارک' },
  { id: 10, title: 'تکمیل مدارک شده توسط مشتری' },
  { id: 15, title: 'در حال پیگیری' },
  { id: 20, title: 'رد شده' },
  { id: 25, title: 'تایید شده' },
  { id: 30, title: 'اعطا شده' },
]

export const siteContentKeys = {
  NafisSlider1: 'Nafis_Slider1',
  NafisCorporators: 'Nafis_Corporators',
  NafisSection1: 'Nafis_Section1',
  NafisComments: 'Nafis_Comments',
  DefaulTopSection: 'Default_TopSection'
}

export const siteContentRootPath = '/siteContents/'
